/**
 * Absolute POS paths. The register is mounted at / on pos.<domain>, at /pos (or
 * /pwa/pos) on the main host. Relative links inside the POS's "/*" route resolved
 * against the current page (/pos/tables + "login" = /pos/tables/login, again and
 * again), so every POS navigation builds its path here.
 */
import { pwaBase, pwaPath } from '@/utils/getBasePath';

export const posBase = () => pwaBase('pos');
export const posPath = (route = '') => pwaPath('pos', route);
